import { useRowSelect, useTable } from 'react-table';
import React, { ReactNode, useEffect } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import ReactPaginate from 'react-paginate';
import { FcPrevious } from 'react-icons/fc';
import { FcNext } from 'react-icons/fc';
import SelectMenu, { ISelectMenuItemValue } from '../../form-control/SelectMenu';
import Loader from '../../Loader';
import Input from '../../form-control/Input';
import DashboardDatePickers, { SelectedDateRange } from '../../dashboard/tabs/date-range-selector/datePicker';
import { NoDataIcon } from '../../../resources/icons/icons';
import NoDataFound from '../NoDataFound';
import { ITableFilterItem } from '../TableFilter/TableFilterForm';
// import NotFound from '../resources/icons/NoResults.jpg';

function GTable({
  columns,
  data,
  selectionChanged,
  classes,
  hideTableHeader,
  stickyHeader = true,
  showSearch = true,
  searchPlaceholder = 'Search',
  onSearch,
  topActions = [],
  tableType,
  showPagination = true,
  paginationData,
  onPageChange,
  showPerPage,
  onShowPerPageChange,
  onRowClick,
  loading,
  columnClasses,
  propBasedColumnClasses,
  actionElement,
  showDateRangeSelector = false,
  onDateChange,
  otherTopActions,
  tableId,
  tableContainerId,
  showHeaders = true,
  filterElem,
  selectedFilters,
  onRemoveFilter
}: ITableProps) {
  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    // @ts-ignore
    state: { selectedRows }
    // @ts-ignore
  } = useTable<any>({ columns, data }, useRowSelect);

  const [adminScrollEnd, setAdminScrollEnd] = React.useState<boolean>(false);

  useEffect(() => {
    if (selectionChanged) {
      selectionChanged(selectedRows);
    }
  }, [selectedRows]);

  useEffect(() => {
    const adminScrollContainer: HTMLElement = document.getElementById(
      'admin-members-scrollarea'
    ) as HTMLElement;
    if (adminScrollContainer) {
      adminScrollContainer.addEventListener('scroll', () => {
        if (
          adminScrollContainer.scrollHeight - adminScrollContainer.scrollTop ===
          adminScrollContainer.clientHeight
        ) {
          setAdminScrollEnd(true);
        }
      });
      adminScrollContainer.addEventListener('resize', () => {
        setAdminScrollEnd(false);
      });
    }
  }, []);

  // const { getExportButtonProps } = useTableExport({data, columns});

  return (
    <>
      {data && (
        <div>
          {/* <button
            {...getExportButtonProps()}>
            Export CSV
          </button> */}

          <div className=" flex flex-col md:flex-row md:justify-between justify-center items-start md:items-center gap-5">
            {/* {topActions && (
              <div className="flex items-center gap-5">
                {Array.isArray(topActions) ? (
                  <>
                    <ul className="flex gap-4 items-center">
                      {topActions?.map((action: ITableTopActionItem, index: number) => (
                        <li
                          key={index}
                          className={clsx(
                            'hover:underline underline-offset-8 decoration-2 decoration-primary-main cursor-pointer',
                            { ['underline']: action.active }
                          )}
                          onClick={action.callback}>
                          {action.label}
                        </li>
                      ))}
                    </ul>

                    <div className="">{otherTopActions}</div>
                  </>
                ) : (
                  <>{topActions}</>
                )}
              </div>
            )} */}
            <div className='flex flex-col md:flex-row gap-4 items-center'>
              {filterElem && <>{filterElem}</>}
              {showSearch && (
                <div className="min-w-fit">
                  <Input
                    type="search"
                    id={'search'}
                    placeholder={searchPlaceholder}
                    prepend={<MagnifyingGlassIcon width={'15px'} className="text-[#828282]" />}
                    onChange={(e: any) => {
                      onSearch?.(e.target.value);
                    }}
                    className="rounded-[30px] h-[45px] border-[1px] focus:[#455A64] bg-[#FFFFFF] dark:bg-slate-900 !pl-10 w-full md:w-80"
                  />
                </div>
              )}
            </div>

            {/* Right side of GTable topper */}
            <div className="flex flex-col md:flex-row gap-4 items-center" title={searchPlaceholder}>

              {showDateRangeSelector && (
                <DashboardDatePickers
                  onSubmit={(data: SelectedDateRange) => {
                    onDateChange?.(data);
                  }}
                />
              )}
              {showPagination && paginationData && (
                <div className="flex items-center space-x-4">
                  <span className='text-sm md:text-base'>
                    {paginationData.from} to {paginationData.to} of {paginationData.total} items
                  </span>
                  <div className="space-x-2 flex items-center text-sm md:text-base">
                    <span>Show</span>
                    <SelectMenu
                      name=""
                      listSelectedValue={String(showPerPage)}
                      onChange={(val: ISelectMenuItemValue) => {
                        onShowPerPageChange?.(Number(val ?? 25));
                      }}
                      list={[10, 25, 50, 75, 100]}
                    />
                  </div>
                </div>
              )}

              {actionElement && <>{actionElement}</>}
            </div>
          </div>

          {/* Show selected filters */}
          {selectedFilters && (
            <div className="flex items-center flex-wrap space-y-1 pb-2">
              {selectedFilters?.map((filter: ITableFilterItem, index: number) => (
                <>
                  {(filter?.value || filter?.value?.to || filter?.value?.from) && (
                    <div
                      className="whitespace-nowrap bg-teal-600 text-white px-2 py-1 mr-2 rounded flex text-xs items-center gap-1"
                      key={index}>
                      <span>{filter.label} :</span>
                      <>
                        {typeof filter.value === 'string' || typeof filter.value === 'number' ? (
                          filter.value
                        ) : (
                          <span>
                            {filter?.value?.from}{' '}
                            {filter?.value?.to ? `to ${filter?.value?.to}` : ''}
                          </span>
                        )}
                      </>
                      <XMarkIcon
                        className="w-[16px] ml-2 cursor-pointer"
                        onClick={() => onRemoveFilter?.(filter, index)}
                      />
                    </div>
                  )}
                </>
              ))}
            </div>
          )}
          <div
            id={tableContainerId}
            className={clsx(
              'overflow-x-auto shadow-md mt-4 text-[12px]',
              // { ["h-[calc(100vh-250px)]"]: data?.length > 0 },
              classes
            )}>
            <table {...getTableProps()} className="w-full px-[0.5rem] relative" id={tableId}>
              {showHeaders && (
                <thead>
                  {headerGroups?.map((headerGroup: any, i: any) => {
                    return (
                      <tr
                        key={i}
                        {...headerGroup.getHeaderGroupProps()}
                        className="first:hidden py-[0.5rem] text-left border-[1px] border-gray-300 dark:border-primary-dark-border_active rounded">
                        <>
                          {headerGroup.headers?.map((column: any, i: number) => {
                            if (!column.restricted) {
                              return (
                                <th
                                  key={i}
                                  {...column.getHeaderProps()}
                                  className={clsx('px-[0.6rem] top-0 bg-[#FFFFFF] dark:bg-primary-dark-secondary py-2', {
                                    ['sticky']: stickyHeader
                                  })}>
                                  {column.render('Header')}
                                </th>
                              );
                            }
                            return null;
                          })}
                        </>
                      </tr>
                    );
                  })}
                </thead>
              )}

              <tbody>
                {rows?.map((row: any, i: number) => {
                  return (
                    // @ts-ignore
                    prepareRow(row) || (
                      <tr
                        key={i}
                        {...row.getRowProps()}
                        className={clsx('border-b border-b-gray-200 dark:border-b-primary-dark-border_active', {
                          ['cursor-pointer']: onRowClick
                        })}
                        onClick={() => {
                          onRowClick?.(row.original);
                        }}>
                        {row.cells?.map((cell: any) => {
                          if (!cell.column.restricted) {
                            return (
                              <td
                                key={i}
                                {...cell.getCellProps()}
                                className={clsx(
                                  'text-left py-[0.6rem] px-[0.6rem] text-small',
                                  columnClasses,
                                  propBasedColumnClasses?.(row.original)
                                )}>
                                {cell.render('Cell')}
                              </td>
                            );
                          }
                          return null;
                        })}
                      </tr>
                    )
                  );
                })}
              </tbody>
            </table>
            {showPagination && paginationData && paginationData.total_pages > 1 && (
              <ReactPaginate
                breakLabel="..."
                nextLabel={<FcNext />}
                onPageChange={(event) => {
                  onPageChange?.(event.selected);
                }}
                pageRangeDisplayed={5}
                pageCount={
                  paginationData?.total_pages
                    ? paginationData?.total_pages
                    : paginationData?.total / paginationData?.per_page
                }
                previousLabel={<FcPrevious />}
                containerClassName={'flex justify-center items-center p-4 space-x-2'}
                pageClassName={
                  'w-[36px] h-[36px] text-[#8A8383] border-[1px] border-[#D8E5EB] dark:border-primary-dark-border_active rounded-[3px] flex justify-center items-center text-base'
                }
                activeClassName={'bg-primary-main text-white'}
                activeLinkClassName={'text-white border-primary-main'}
                initialPage={paginationData.current_page && paginationData.current_page > 0 ? paginationData.current_page - 1 : paginationData.current_page}
              // renderOnZeroPageCount={null}
              />
            )}
          </div>

          {loading && (
            <div className="w-full text-center py-10">
              <Loader message={`Loading ${tableType ?? 'data'}. Please wait...`} logoLoader />
            </div>
          )}
          {data?.length === 0 && !loading && (
            <div className="w-full h-full text-center py-10">
              <NoDataFound text={`No ${tableType} found`} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default GTable;

interface ITableProps {
  columns: any;
  data: any[];
  selectionChanged?: any;
  classes?: string;
  hideTableHeader?: boolean;
  stickyHeader?: boolean;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearch?: (searchString: string) => void;
  topActions?: ITableTopActionItem[] | JSX.Element | ReactNode;
  otherTopActions?: JSX.Element | ReactNode;
  tableType?: string;
  showPagination?: boolean;
  paginationData?: ITablePaginationData;
  onPageChange?: (page: number) => void;
  showPerPage?: number;
  onShowPerPageChange?: (page: number) => void;
  onRowClick?: (data: any) => void;
  loading?: boolean;
  columnClasses?: string;
  propBasedColumnClasses?: (data: any) => string;
  actionElement?: JSX.Element | Element | ReactNode;
  showDateRangeSelector?: boolean;
  onDateChange?: (data: any) => void;
  tableId?: string;
  tableContainerId?: string;
  showHeaders?: boolean;
  filterElem?: JSX.Element | Element;
  selectedFilters?: ITableFilterItem[];
  onRemoveFilter?: (filter: ITableFilterItem, index: number) => void;
}

export interface ITableTopActionItem {
  id: string;
  label: string;
  callback: () => void;
  active: boolean;
}

export interface ITablePaginationData {
  total: number;
  per_page: number;
  total_pages: number;
  from?: number;
  to?: number;
  current_page?: number;
}

export interface ITableRowAction {
  label: string;
  callback: (data?: any) => void;
  data?: any;
}
export interface ITableAction {
  label: string;
  callback: (data?: any) => void;
}
